import usericon from "../images/svg/man-438081_960_720.svg";
import loginimage from "../images/svg/ConnectAI_logo.png";
import dashboardIcon from "../images/svg/dashboard.svg";
import logo from "../images/svg/1ch-logo.png";
import icon from "../images/svg/1ch-logo-no-text.png";

export const LOCAL_IMAGE = {
  userIcon: usericon,
  dashboardIcon: dashboardIcon,
  loginimage: loginimage,
  logo: logo,
  icon: icon,
};
